import { SolutionInstance } from '@/pages/marketplace/solution/type';
import { WorkspaceT } from '@/pages/workgroup/type';
import { atom } from 'jotai';

export const workSpacesAtom = atom<WorkspaceT[]>([]);

export const workSpacesROUpdateAtom = atom<WorkspaceT[]>([]);

export const deletingSpaceIdsAtom = atom<Set<string>>(new Set<string>());

export const solutionsAtom = atom<SolutionInstance[]>([]);
